import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    orderNewCard: 'Order a card',
    requestNewCard: 'Request a new card',
    title: 'Cards',
  },
  fr: {
    orderNewCard: 'Commander une carte',
    requestNewCard: 'Demander une nouvelle carte',
    title: 'Cartes bancaires',
  },
} as const);

export default locales;
